export default data => {

    const ordererRows = [
        '', // <= force any matched index to be truthy
        'Non Barb-reported channels',
        'All Other Broadcasters'
    ];

    return data.sort((a, b) => {
        if (a.table === "3" || b.table === "3") {
            return 0;
        }

        const aIndex = ordererRows.indexOf(a.station_name) || -1;
        const bIndex = ordererRows.indexOf(b.station_name) || -1;

        if (aIndex === bIndex) {
            return 0;
        }

        return aIndex > bIndex ? 1 : -1;
    })
}
